import { render, staticRenderFns } from "./appointmentSearch.vue?vue&type=template&id=5fb6f670&scoped=true&"
import script from "./appointmentSearch.vue?vue&type=script&lang=js&"
export * from "./appointmentSearch.vue?vue&type=script&lang=js&"
import style0 from "./appointmentSearch.vue?vue&type=style&index=0&id=5fb6f670&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb6f670",
  null
  
)

export default component.exports